import * as React from "react"
import BeltPage from "../../components/belt-page"
import LightbulbFlash from "../../svgs/lightbulb-flash-solid.svg"
import BasicContentCMS from "../../svgs/components/minimalist-pages/basic-content-cms"
import InvaderAlert from "../../svgs/components/minimalist-pages/invader-alert"
import ShareOfVoice from "../../svgs/components/minimalist-pages/share-of-voice"
import WalmartSearchBoost from "../../svgs/components/minimalist-pages/walmart-search-boost"
import HandsHelping from "../../svgs/hands-helping-solid.svg"
import SKUie from "../../svgs/SKUie.svg"
import Search from "../../svgs/search-solid.svg"
import Tachometer from "../../svgs/tachometer-solid.svg"
import ChalkboardTeacher from "../../svgs/chalkboard-teacher-solid.svg"
import ContentCenter from "../../svgs/content-center.svg"

const SKUNinjaSubscription = ({location}) => (
    <BeltPage 
        location={location}
        bgColor={'bg-blue'}
        color={'blue'}
        hex={'#00aeef'}
        iconBackgroundColor={'icon-background-primary'}
        blogCategory={'Case Study'}
        bannerBtnColor={'btn-yellow'}
        bannerBtnContactUs={false}
        pillar={false}
        icon={<SKUie/>}
        title={'SKU Ninja Subscription'}
        altTitle={'SKU Ninja'}
        metaTitle={"SKU Ninja Elite Subscription"}
        metaDescription={"Combine all of SKU Ninja's powerful ecommerce software to create and execute a winning Walmart strategy. Get all the tools you need to win on Walmart.com."}
        subtitle={'YOUR ALL-IN-ONE SOFTWARE PACKAGE FOR WALMART ECOMMERCE EXCELLENCE'}
        subheader={'Use SKU Ninja’s simplified software solutions to streamline your Walmart operations and take your business on Walmart.com to the next level.'}
        skuNinjaSubCard={true}
        tabsTitle={["Get Full Access to All of SKU Ninja's", <br/>, 'Walmart.com Tools']}
        tools={[
            {
                title: 'Content Center', 
                content: [
                    'Easily update the content on your Walmart item pages',
                    'Audit the content you have live on Walmart.com',
                    'Manage your Walmart items from SKU Ninja’s online dashboard'
                ],
                graphic: <BasicContentCMS className='w-80 tool-abstraction'/>,
            },
            {
                title: 'Get Found', 
                content: [
                    'View Content Quality Scores and the top issues affecting them',
                    'Monitor your items for missing content or opportunities to improve',
                    'Get essential information about your items at a glance'
                ],
                graphic: <WalmartSearchBoost className='w-80 tool-abstraction'/>,
            },
            {
                title: 'Insights', 
                content: [
                    'Get Walmart data and insights you won’t find anywhere else',
                    'Find demographic information about shoppers visiting your item pages',
                    'Use artificial intelligence to learn what’s most important to your shoppers'
                ],
                graphic: <InvaderAlert className='w-80 tool-abstraction'/>,
            },
            {
                title: 'Win Search', 
                content: [
                    'Measure your item’s search visibility over time',
                    'Identify the most visible competitors in your category’s search results',
                    'Discover high-traffic SEO keywords on Walmart.com'
                ],
                graphic: <ShareOfVoice className='w-80 tool-abstraction'/>,
            }
        ]}
        benefits={{
            title: 'SKU Ninja Subscription Benefits',
            cards: [
                {
                    icon: <ContentCenter/>,
                    title: 'Simplified Item Page Management',
                    body: 'Use SKU Ninja to manage your Walmart items with our easy-to-use interface.'
                },
                {
                    icon: <Search/>,
                    title: 'Exclusive Walmart Insights',
                    body: "SKU Ninja’s Insights tools give you information on your Walmart items you won’t get anywhere else."
                },
                {
                    icon: <Tachometer/>,
                    title: 'Optimize Your Item Pages',
                    body: 'Get actionable insights on exactly how to make your items more discoverable on Walmart.com.'
                },
                {
                    icon: <ChalkboardTeacher/>,
                    title: 'Customer Success',
                    body: 'Every new SKU Ninja subscriber gets free training from our Customer Success team.'
                },
                {
                    icon: <LightbulbFlash/>,
                    title: 'Insights Consultation',
                    body: 'Our Insights team will provide recommendations on how to grow your Walmart business using SKU Ninja.'
                },
                {
                    icon: <HandsHelping/>,
                    title: 'SKU Ninja Support',
                    body: 'Get help with any Walmart questions or issues through our fast & responsive helpdesk.'
                }
            ]
        }}
        contactUsTitle={'Find the right solution for your Walmart business'}
    />
)

export default SKUNinjaSubscription